import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { breadTypeOptions } from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import Select from 'react-select'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'
import { isNotNumericDecimal } from 'context/Utilities'
import Switch from 'react-switch'

const BreadPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    BreadType: item.BreadType,
    BreadSize: item.BreadSize,
    WholeWheatCert: item.WholeWheatCert,
  })

  const methods = useFormContext()
  const { setSelectReviewer, setSwitchReviewer, onChangeReviewer, asterisk } = useFormUtils()

  useEffect(() => {
    if (item !== null) {
      const { BreadType, BreadSize, WholeWheatCert } = item
      setPackaging({
        BreadType,
        BreadSize,
        WholeWheatCert,
      })
    }
    // eslint-disable-next-line
    }, [item])

  return (
    <Row>
      <Col xs={6}>
        <h6>Type {asterisk}</h6>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={breadTypeOptions}
          defaultValue={{
            label: packaging.BreadType,
            value: packaging.BreadType,
          }}
          name="BreadType"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Type'}
          onChange={([selected, value]) => {
            setSelectReviewer(item, selected, value)
            return selected
          }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="BreadType"
            message={'⚠ Type is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <FormGroup>
          <h6>Size {asterisk}</h6>
          {/* <Controller
            as={Input}
            name="BreadSize"
            placeholder={'Size'}
            defaultValue={packaging.BreadSize}
            control={methods.control}
            rules={{ required: true, maxLength: 15 }}
            onChange={([event]) => {
              onChangeReviewer(item, event)
              return event
            }}
            disabled={true}
          />
          <p className={'text-danger'}>
            {methods.errors.BreadSize &&
              methods.errors.BreadSize.type === 'required' && (
                <Alert color="danger" className={'mt-3'}>
                  ⚠ Bread size is required.
                </Alert>
              )}
            {methods.errors.BreadSize &&
              methods.errors.BreadSize.type === 'maxLength' && (
                <Alert color="danger" className={'mt-3'}>
                  ⚠ Bread size exceeds 15 characters.
                </Alert>
              )}
          </p>{' '} */}
          <Controller
            as={Input}
            name="BreadSize"
            placeholder={'12 - 48 ounces'}
            defaultValue={packaging.BreadSize}
            control={methods.control}
            rules={{
              validate: containerSize =>
                containerSize >= 12 && containerSize <= 48,
              maxLength: {
                value: 5,
                message: '⚠ Size exceeds 5 characters.',
              },
            }}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            onChange={([event]) => {
              onChangeReviewer(item, event)
              return event
            }}
            disabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="BreadSize"
              message={'⚠ Size must be between 16 - 18 ounces.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>
              I certify that this product has “100% Whole Wheat” printed on the
              front label. {asterisk}
            </strong>
          </p>
          <Controller
            as={Switch}
            name="WholeWheatCert"
            id="WholeWheatCert"
            control={methods.control}
            defaultValue={item.WholeWheatCert}
            onChange={([checked, event, id]) => {
              setSwitchReviewer(item, checked, event, id)
              return checked
            }}
            rules={{
              validate: WholeWheatCert => WholeWheatCert === true,
            }}
            disabled={isDisabled}
          />
          <br />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="WholeWheatCert"
              message={
                "⚠ You must certify that this product has “100% Whole Wheat” printed on the front label. If the product doesn't contain the label, it cannot be authorized."
              }
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
    </Row>
  )
}

BreadPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default BreadPackageReview
